import store from "../store"

export const notify = (text, msgType = "", pinned = false) => {
  let currentNotifications = store.getters.getNotifications()
  store.dispatch(
    "setNotifications",
    currentNotifications.concat([
      {
        title: "",
        text: text,
        type: msgType,
        pinned: pinned,
      },
    ])
  )
}
